export default {
  // General UI elements
  save: "Сохранить",
  saving: "Сохранение",
  cancel: "Отмена",
  edit: "редактировать",
  delete: "Удалить",
  profile: "Профиль",
  settings: "Настройки",
  logout: "Выйти",
  language: "Язык",
  loading: "Загрузка",
  submit: "Отправить",
  search: "Поиск...",
  back: "Назад",
  next: "Далее",
  previous: "Предыдущий",
  continue: "Продолжить",
  done: "Готово",
  error: "Ошибка",
  success: "Успешно",
  warning: "Предупреждение",
  info: "Информация",
  close: "Закрыть",
  open: "Открыть",
  yes: "Да",
  no: "Нет",
  ok: "OK",
   
  // Authentication
  auth: {
    signIn: "Войти",
    signUp: "Зарегистрироваться",
    signOut: "Выйти",
    forgotPassword: "Забыли пароль?",
    resetPassword: "Сбросить пароль",
    sendResetLink: "Отправить ссылку для сброса",
    createAccount: "Создать аккаунт",
    alreadyHaveAccount: "Уже есть аккаунт?",
    dontHaveAccount: "Нет аккаунта?",
    or: "Или",
    continueWith: "Продолжить с",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    twitter: "Twitter",
    passwordRequirements: "Пароль должен содержать не менее 8 символов",
    passwordMatch: "Пароли должны совпадать",
    emailInvalid: "Пожалуйста, введите действительный адрес электронной почты"
  },
  
  // Profile specific
  username: "Имя пользователя",
  email: "Эл. почта",
  password: "Пароль",
  confirmPassword: "Подтвердите пароль",
  joinDate: "Дата регистрации",
  streak: "Серия",
  xp: "XP",
  plan: "План",
  free: "Бесплатный",
  pro: "Про",
  premium: "Премиум",
  referralCode: "Реферальный код",
  share: "Поделиться",
  copy: "Копировать",
  copied: "Скопировано!",
  contactUs: "Связаться с нами",
  termsOfService: "Условия использования",
  privacyPolicy: "Политика конфиденциальности",
  accountSettings: "Настройки аккаунта",
  changePassword: "Изменить пароль",
  deleteAccount: "Удалить аккаунт",
  deleteAccountConfirm: "Вы уверены, что хотите удалить свой аккаунт? Это действие нельзя отменить.",
  updateProfile: "Обновить профиль",
  profileUpdated: "Профиль успешно обновлен",
  memberSince: "Участник с",
  noSetsYet: "Пока Нет Наборов :(",
  upgradeToPro: "Обновить до Pro",
  recentActivity: "Недавняя активность",
  shareWithAFriend: "Поделиться с другом",
  contactTheTeam: "Связаться с Командой",
  termsAndConditions: "Условия и Положения",
  editUsername: "Изменить Имя Пользователя:",
  logOut: "Выйти",
  usernameError1: "Имя пользователя не может быть пустым",
  usernameError2: "Пожалуйста, введите другое или новое имя пользователя",
  usernameError3: "Имя пользователя не может содержать пробелы",
  usernameError4: "Имя пользователя не может содержать заглавные буквы",
  usernameError5: "Имя пользователя не может содержать специальные символы",
  usernameError6: "Имя пользователя должно быть от 4 до 18 символов",
  usernameError7: "Имя пользователя содержит неприемлемый контент",
  usernameError8: "Это имя пользователя уже занято",
  clickOrDragAndDrop: "Нажмите или перетащите файл для загрузки",
  confirm: "Подтвердить",
  retake: "Переснять",

  // BottomNav
  profile: "Профиль",
  home: "Главная",
  library: "Моя Библиотека",
  saved: "Сохраненные",
  rankings: "Рейтинги",

  // Feature
  backToLibrary: "Вернуться в Библиотеку",
  exploreSets: "Исследовать Наборы",
  communitySets: "Наборы Сообщества",
  mySets: "Мои Наборы",
  alreadyAdded: "Уже Добавлен",
  addToLibrary: "Добавить в Библиотеку",
  loading: "Загрузка...",
  loadMoreSets: "Загрузить Больше Наборов",
  by: "Автор",
  makePublic: "Публичным",
  subscriptionRequired: "Требуется подписка",
  subscriptionRequiredMessage: "Вы можете иметь только 10 наборов одновременно в библиотеке. Обновитесь до Premium для неограниченных наборов!",

  // My Library
  deleteSet: "Удалить Набор",
  deleteSetConfirmation: "Вы уверены, что хотите удалить этот набор?",
  yesDelete: "Да, Удалить",
  collections: "Публичные Наборы",
  myLibrary: "Моя Библиотека",
  outOf10Sets: "из 10 добавленных наборов",
  switchBackToPro: "Переключиться на Pro",
  upgradeToPro: "Обновить до Pro",
  outOf10OnFree: "из 10 добавленных наборов бесплатно.",
  letMeCook: "Позвольте мне приготовить",
  selectMode: "Выбрать Режим",
  multipleChoice: "Выбор нескольких вариантов",
  flashcards: "Флеш-карты",
  freeResponse: "Свободный ответ",
  proOnly: "Только для Pro",
  leaderboard: "Рейтинг",
  favorites: "Избранное",
  profile: "Профиль",
  reportBugs: "Сообщить о багах",

  // Question Card
  correctMessage: "Правильно! Вы Приготовили.",
  typeYourAnswer: "Напишите свой ответ...",
  submitAnswer: "Отправить Ответ",
  responseCannotBeBlank: "Ответ не может быть пустым",
  noAnswerAvailable: "Ответ не доступен",
  answerGuideline: "Руководство по ответу:",
  pleaseSubmitAnswerFirst: "Пожалуйста, отправьте свой ответ первым",
  revealAnswer: "Показать Ответ",
  hideAnswer: "Скрыть Ответ",
  gradingInProgress: "Оценка в процессе...",
  grading: "Оценка",
  answerGuidelines: "Правила ответа",
  finalScore: "Итоговый балл:",
  evaluateAnswer: "Оценить Oтвет",

  // Saved
  favorites: "Избранное",
  searchQuestions: "Поиск вопросов...",
  noSavedQuestions: "Нет сохраненных вопросов.",

  // Scroller
  loadingMoreQuestions: "Загрузка Больше Вопросов",

  // New Prompt
  deleteSet: "Удалить Набор",
  deleteSetConfirmation: "Вы уверены, что хотите удалить этот набор?",
  yesDelete: "Да, Удалить",
  cancel: "Отмена",
  setLimitReached: "Лимит Наборов Достигнут",
  setLimitError: "Вы можете иметь только 10 наборов одновременно в библиотеке. Обновитесь до Premium для неограниченных наборов!",
  close: "Закрыть",
  uploadNotes: "Загрузить Заметки",
  general: "Общее",
  title: "Заголовок",
  setTitleMessage: "Установите заголовок для ваших AI-сгенерированных вопросов Cookr, чтобы было легко получить к ним доступ позже.",
  titleError1: "Заголовок не может быть пустым",
  titleError2: "Заголовок содержит неприемлемый контент",
  content: "Содержимое",
  setContentMessage: "Скопируйте и вставьте свои заметки, лекции или любой другой текстовый контент.",
  contentError1: "Содержимое не может быть пустым",
  contentError2: "Содержимое содержит неприемлемый контент",
  subject: "Тема",
  setSubjectMessage: "О чем этот контент?",
  subjectError1: "Тема не может быть пустой",
  subjectError2: "Тема содержит неприемлемый контент",

  // Payment Confirmation
  returnToProfile: "Вернуться к Профилю",

  // Plans
  confirmSwitch: "Подтвердить Переключение на Бесплатный План",
  confirmSwitchMessage: "Вы уверены, что хотите переключиться на Бесплатный План? Вы потеряете доступ к премиум-функциям.",
  buttonConfirm: "Подтвердить Переключение",
  processing: "Обработка...",
  unlimitedScrolling: "Неограниченный Прокрутка",
  unlimitedSubjects: "Неограниченные Темы",
  aiTutorBot: "AI-Бот-Репетитор",
  newFeatureAccess: "Доступ к Новым Функциям",
  saveScrolls: "Сохранять Scrolls",
  infiniteNoteUploads: "Бесконечные Загрузки Заметок",
  answerExplanations: "Объяснения Ответов",
  shareScrolls: "Поделиться Scrolls",
  everythingInStandard: "Всё в Стандартном",
  current: "Текущий",
  switchOver: "Переключиться на",
  forever: "/навсегда",
  monthly: "/ежемесячно",
  yearly: "/ежегодно",

  // Leaderboard
  leaderboard: "Рейтинг",

  // Home.js
  pickASubject: "Выберите тему, чтобы начать сессию!",

  // scrollerLoader
  generatingContent: "Генерация Содержимого...",

  // Dropdown
  choose: "Выбрать",
  titleTooLong: "Заголовок не может содержать более 100 символов",


}




